import { render } from "./XmlMappingPositionForm.vue?vue&type=template&id=402d9602&ts=true"
import script from "./XmlMappingPositionForm.vue?vue&type=script&lang=ts"
export * from "./XmlMappingPositionForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__